module.exports = __webpack_public_path__ + "static/media/khoi.944db799.jpg";